import { Injectable, inject } from '@angular/core';
import { CoreAPILoader } from 'src/app/ajs-upgraded-providers';
import { DedupingGeneratorService } from 'src/app/app-common/services/deduping-generator.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CoreApiLoaderService implements CoreAPILoader {
  private dedupingGeneratorService = inject(DedupingGeneratorService);
  private coreApiLoader: () => Promise<any>;

  constructor() {
    this.coreApiLoader = this.dedupingGeneratorService.generate(
      'core',
      'v1',
      this.getBaseUrl(),
    );
  }

  load(): Promise<any> {
    return this.coreApiLoader();
  }

  private getBaseUrl() {
    const coreApiBaseUrl = new URLSearchParams(window.location.search).get(
      'core_api_base_url',
    );

    return coreApiBaseUrl ? `${coreApiBaseUrl}/_ah/api` : environment.CORE_URL;
  }
}
